



























import { Component, Vue } from "vue-property-decorator";
import {Api} from '@/api/Api';
import {XFormValidate} from '@/common/form/XFormValidate';

@Component
export default class IvtEditUI extends Vue {
    private ivt: any = {
        pCode:'',
        terminalNo: '',
        sn: '',
    };

    // 必填项校验规则定义
    public checkRules: any = {
        pCode:            [{ required: true, message: 'pCode必须填写', trigger: 'blur' }],
        terminalNo:       [{ required: true, message: '门店编号必须填写', trigger: 'blur' }],
        sn:               [{ required: true, message: 'imei必须填写', trigger: 'blur' }],
    };
    
    // 绑定数据
    public mounted() {
        
    }

    private doRegister() {
        const formValidate = new XFormValidate.XForm(this)
                        .add(new XFormValidate.XText('pCode', this.ivt.pCode))
                        .add(new XFormValidate.XText('门店编号', this.ivt.terminalNo))
                        .add(new XFormValidate.XText('imei', this.ivt.sn))
                        .validate();
        if (formValidate !== true) {
            return;
        }

        // 新增
        Api.prize.registerIvt(this.ivt.pCode, this.ivt.terminalNo, this.ivt.sn).then(()=>{
            this.dialogPage.close({
                code: 'OK',
                ivt: null,
            });
        });
    }
    // 取消
    private doCancelClick() {
        this.dialogPage.close({
            code: 'CANCEL',
        });
    }
}
